import React,{useState,useEffect} from "react";
import sliderInner from '../assets/images/sliderInner.jpg';
import leafIcn from '../assets/images/slider-shape-5.png';
import { useNavigate } from "react-router-dom";
import subThemes from "../helper/SubThemes_List";
import sunstableicons1 from "../assets/images/icon/homeIcons/Theme2Icons/icon-1.png"
import sunstableicons2 from "../assets/images/icon/homeIcons/Theme2Icons/icon-2.png"
import sunstableicons3 from "../assets/images/icon/homeIcons/Theme2Icons/icon-3.png"
import sunstableicons4 from "../assets/images/icon/homeIcons/Theme2Icons/icon-4.png"


function AdoptFood() {
  const navigate = useNavigate();
  const [themeData, setThemeData] = useState(null);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()

  const handleRoute = (data) => {
    localStorage.setItem('sub_themes', subThemes['Adopt sustainable food systems'][data].value);
    navigate('/details');
  };
  const fetchDetails = async (data) => {
    try {
      const response = await fetch(`https://ecoclubs.education.gov.in/api/get-participants-details?theme=Adopt sustainable food systems`); // Replace with your API URL
      const result = await response.json();
      setThemeData(result?.data); // Store fetched data in state
    } catch (error) {
      console.error("Error fetching theme data:", error);
    }

    
  };

  useEffect(()=>{
    fetchDetails();
  },[])

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
        <div className="sliderInrHdng">
        <h2>Eco Clubs <span className="hdngBrkr">for Mission LiFE Themes</span></h2>
        </div>
      </section>

      <section className="sevenScopeSec reduceWasteSec">
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          <h2>Adopt<span className="hdngBrkr">Sustainable Food Systems</span> </h2>
          <button className="button green btn-login-signup loginBtnnewhm" style={{position:"absolute", right:"6%"}} onClick={()=>navigate(-1)} >Back</button>       
          <div className="sevenScopeBox">
            <ul className="themeGrid">
              {[
                { label: "School Nutrition Garden", icon: sunstableicons1 },
                { label: "Classroom Activities", icon: sunstableicons2 },
                { label: "Competitions", icon: sunstableicons3 },
                { label: "Others", icon: sunstableicons4 }
              ].map((theme, index) => (
                <li key={index} onClick={() => handleRoute(index)}>
                  <div className="themeBox orange">
                    <div className="themeBoxIcn"><img src={theme.icon} alt="" /></div>
                    <div className="themeBoxCnt">{theme.label}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className='stackHolderSec'>
        <img className="slider__shape-13 stackholdrLf" src={leafIcn} alt="" />
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          {/* <h2><span className="hdngBrkr">Stakeholders</span> Involved</h2> */}
          <div className="stackHldrCntDiv">
  <div className="row">
    <div className="col-6 stackLft">
      <h2 className="sbHdng">participation AT A GLANCE</h2>
      <div className="stackLftIn">
        <ul>
          <li>
            States/UTs <span>{36}</span>
          </li>
          <li>
            Districts <span>{themeData ? themeData.districts : 0}</span>
          </li>
          <li>
            Total Schools <span>{themeData ? themeData.totalSchools : 0}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
        </div>
      </section>
    </>
  );
}

export default AdoptFood;
